import { Link } from 'react-router-dom'
import { Home, AlertTriangle } from 'lucide-react'
import './NotFound.css'

export default function NotFound() {
  return (
    <div className="not-found">
      <div className="not-found-content">
        <div className="error-icon">
          <AlertTriangle size={64} />
        </div>
        <h1>404</h1>
        <h2>Page Not Found</h2>
        <p>The page you are looking for doesn't exist or has been moved.</p>
        <Link to="/" className="btn btn-primary">
          <Home size={18} />
          Back to Dashboard
        </Link>
      </div>
    </div>
  )
}
